import { Typography } from '@iheartjane/reefer';
import type { ChangeEvent } from 'react';
import { PatternFormat } from 'react-number-format';

import { formatTime } from '@jane/shared/util';

const formatIncomingDate = (date: string) =>
  formatTime({
    time: date,
    outputFormat: 'MM/DD/YYYY',
    inputFormat: 'YYYY-MM-DD',
  });

const formatOutgoingDate = (date: string) =>
  date === 'mm/dd/yyyy'
    ? ''
    : Date.parse(date)
      ? formatTime({
          time: date,
          outputFormat: 'YYYY-MM-DD',
          inputFormat: 'MM/DD/YYYY',
        })
      : date;

const DATE_FORMAT = '##/##/####';
const DATE_MASK = ['m', 'm', 'd', 'd', 'y', 'y', 'y', 'y'];

interface DateInputProps {
  className?: string;
  date: string;
  invalid: boolean;
  onChange: (arg: string) => void;
  placeholder?: string;
}

// This is a masked input component that does not implement form validations.
// This should only be used when it's necessary to render a date input outside of a form.
export const DateInput = ({
  date,
  onChange,
  invalid,
  className,
  placeholder,
}: DateInputProps) => {
  return (
    <Typography>
      <PatternFormat
        defaultValue={date ? formatIncomingDate(date) : ''}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          onChange(formatOutgoingDate(event.target.value))
        }
        format={DATE_FORMAT}
        mask={DATE_MASK}
        aria-invalid={invalid}
        placeholder={placeholder || 'mm/dd/yyyy'}
        type="tel"
        className={className}
      />
    </Typography>
  );
};
